import { render } from "./accountDeletionCanceled.vue?vue&type=template&id=61af1f3b&scoped=true"
import script from "./accountDeletionCanceled.vue?vue&type=script&lang=js"
export * from "./accountDeletionCanceled.vue?vue&type=script&lang=js"

import "./accountDeletionCanceled.vue?vue&type=style&index=0&id=61af1f3b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61af1f3b"]])

export default __exports__